module.exports = __webpack_public_path__ + "static/media/JAGPersonas.8e4e2136.png";